<template>
  <div>
    <div
      v-for="article in component.articles"
      :key="article.id"
      :class="slideClass"
    >
      <nuxt-link
        :to="article.permalink"
        class=""
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/Article"
      >
        <div class="block h-240 overflow-hidden rounded-lg">
          <nuxt-img
            :src="article.image"
            preset="standard"
            sizes="mob375:100vw mob390:100vw mob414:100vw desk:404px"
            alt="Relaterade artiklar-bild"
            class="object-center object-cover w-full h-full"
            itemprop="image"
          />
        </div>
        <div>
          <h3 class="my-12" itemprop="name">
            {{ article.title }}
          </h3>
          <p
            v-if="showExcerpt || component.showExcerpt"
            class="text-muted text-base-regular mb-12"
          >
            {{ article.excerpt }}
          </p>
          <div class="btn btn--md btn--secondary">
            {{ $lang('article_listing_page', 'read_more') }}
          </div>
        </div>
      </nuxt-link>
    </div>
  </div>
</template>
<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ArticleListingContent',
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    showExcerpt: {
      type: Boolean,
      default: false,
    },
    slideClass: {
      type: String,
      default: '',
    },
  },
});
</script>
